import { useState } from 'react';

const Icon = ({ name, className = '' }) => (
  <span className={`ms-icon ${className}`}>{name}</span>
);

// public/theme.js applies the initial theme class before first paint;
// this component only reads that state and flips it on demand.
const ThemeToggle = ({ className = '' }) => {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains('dark'));

  const toggle = () => {
    const next = !dark;
    document.documentElement.classList.toggle('dark', next);
    try { localStorage.setItem('theme', next ? 'dark' : 'light'); } catch { /* ignore */ }
    setDark(next);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={dark ? 'Light mode' : 'Dark mode'}
      className={`tap-target w-9 h-9 flex items-center justify-center rounded-xl text-stone-500 hover:text-stone-900 hover:bg-stone-100 dark:text-stone-400 dark:hover:text-stone-100 dark:hover:bg-stone-800 transition-colors ${className}`}
    >
      <Icon name={dark ? 'light_mode' : 'dark_mode'} className="text-[20px]" />
    </button>
  );
};

export default ThemeToggle;
